import React, { useState, useEffect } from "react";

const BobOrders = () => {
  const [submittedOrders, setSubmittedOrders] = useState({ recent: [], all: [] });
  const [orders, setOrders] = useState([]);
  const [currentOrder, setCurrentOrder] = useState({
    product: "",
    desc: "",
    qty: "",
    price: "",
    total: "0.00",
    files: [],
  });
  const [poNumber, setPoNumber] = useState("");
  const [allFiles, setAllFiles] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [showSubmittedModal, setShowSubmittedModal] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API_URL}/api/orders`)
      .then(res => res.json())
      .then(data => {
        const now = new Date();
        const recent = data.filter(order => (now - new Date(order.created_at)) / (1000 * 60 * 60 * 24) < 1);
        setSubmittedOrders({ recent, all: data });
      })
      .catch(err => console.error("Error fetching orders:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "files") {
      setCurrentOrder((prev) => ({
        ...prev,
        files: [...prev.files, ...Array.from(files)],
      }));
    } else {
      let updatedValue = value;
      const updatedOrder = { ...currentOrder, [name]: updatedValue };

      const qty = parseFloat(name === "qty" ? value : updatedOrder.qty) || 0;
      const price = parseFloat(name === "price" ? value : updatedOrder.price) || 0;
      updatedOrder.total = (qty * price).toFixed(2);

      setCurrentOrder(updatedOrder);
    }
  };

  const handleRemoveFile = (index) => {
    setCurrentOrder((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  const handleAddOrder = () => {
    if (!poNumber || !currentOrder.product || !currentOrder.qty || !currentOrder.price) {
      alert("Please enter a PO number and fill out required fields.");
      return;
    }
    const fileIndexes = [];
    const fileList = [...allFiles];
    currentOrder.files.forEach((file) => {
      fileIndexes.push(fileList.length);
      fileList.push(file);
    });
    const newOrder = { ...currentOrder, sno: orders.length + 1, poNumber, fileIndexes };
    setOrders([...orders, newOrder]);
    setAllFiles(fileList);
    setCurrentOrder({ product: "", desc: "", qty: "", price: "", total: "0.00", files: [] });
  };

  const handleSubmit = async () => {
    if (orders.length === 0) {
      alert("No orders to submit.");
      return;
    }
    const formData = new FormData();
    formData.append("orders", JSON.stringify(orders));
    allFiles.forEach((file) => formData.append("files", file));
    const response = await fetch(`${API_URL}/api/orders/submit`, {
      method: "POST",
      body: formData,
    });
    if (response.ok) {
      alert("Orders submitted successfully.");
      setOrders([]);
      setPoNumber("");
      setShowForm(false);
      setAllFiles([]);
      const updated = await fetch(`${API_URL}/api/orders`).then(res => res.json());
      const now = new Date();
      const recent = updated.filter(order => (now - new Date(order.created_at)) / (1000 * 60 * 60 * 24) < 1);
      setSubmittedOrders({ recent, all: updated });
    } else {
      alert("Error submitting orders.");
    }
  };

  const handlePrintInvoice = (poNumber, orders) => {
    const subtotal = orders.reduce((sum, order) => sum + parseFloat(order.total || 0), 0);
    const salesTax = (subtotal * 0.04).toFixed(2);
    const total = (subtotal + parseFloat(salesTax)).toFixed(2);
    const invoiceDate = new Date().toLocaleDateString();
    const logoUrl = `${window.location.origin}/img.jpg`;

    const invoiceHtml = `
      <html>
      <head>
        <title>Invoice - ${poNumber}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          .header, .footer { display: flex; justify-content: space-between; align-items: center; }
          .header img { width: 100px; }
          .bill-ship { background-color: #e6f2fa; padding: 10px; margin: 20px 0; display: flex; justify-content: space-between; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: center; }
          .ways-to-pay { margin-top: 30px; text-align: center; }
        </style>
      </head>
      <body>
        <div class="header">
          <div>
            <h2 style="color:#0070c0;">INVOICE</h2>
            <strong>TSS Printing II</strong><br/>
            1139 Central Ave<br/>
            Albany, NY 12205<br/>
            rjesmain05@gmail.com<br/>
            +1 (518) 207-5781
          </div>
          <div>
            <img id="logo" src="${logoUrl}" alt="TSS Printing Logo"/>
          </div>
        </div>

        <div class="bill-ship">
          <div>
            <strong>Bill to</strong><br/>
            TSS Orders<br/>
            Daigle Cleaning Systems<br/>
            20 Center St.<br/>
            Albany, NY 12204
          </div>
          <div>
            <strong>Ship to</strong><br/>
            TSS Orders
          </div>
        </div>

        <h4>Invoice details</h4>
        <p><strong>Invoice no.:</strong> ${poNumber}-${Math.floor(Math.random() * 1000)}</p>
        <p><strong>Invoice date:</strong> ${invoiceDate}</p>

        <table>
          <thead>
            <tr>
              <th>#</th><th>Product</th><th>Description</th><th>Qty</th><th>Rate</th><th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${orders.map((order, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${order.product}</td>
                <td>${order.description || "-"}</td>
                <td>${order.qty}</td>
                <td>$${parseFloat(order.price).toFixed(2)}</td>
                <td>$${parseFloat(order.total).toFixed(2)}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>

        <div style="text-align: right;">
          <p><strong>Subtotal:</strong> $${subtotal.toFixed(2)}</p>
          <p><strong>Sales tax (4%):</strong> $${salesTax}</p>
          <h3><strong>Total:</strong> $${total}</h3>
        </div>

        <script>
          window.onload = function() { window.print(); };
        </script>
      </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(invoiceHtml);
    printWindow.document.close();
  };

  const renderOrderGroups = (ordersArray) => {
    const grouped = ordersArray.reduce((acc, order) => {
      const po = order.po_number || "No PO Number";
      if (!acc[po]) acc[po] = [];
      acc[po].push(order);
      return acc;
    }, {});
    return Object.entries(grouped).map(([poNumber, orders]) => (
      <div key={poNumber} className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6>PO Number: {poNumber}</h6>
          <button className="btn btn-sm btn-outline-primary" onClick={() => handlePrintInvoice(poNumber, orders)}>
            Print Invoice
          </button>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Product</th>
              <th>Description</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
              <th>Files</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.id}>
                <td>{order.id}</td>
                <td>{order.product}</td>
                <td>{order.description}</td>
                <td>{order.qty}</td>
                <td>{order.price}</td>
                <td>{order.total}</td>
                <td>
                  {Array.isArray(JSON.parse(order.file_paths || "[]")) &&
                    JSON.parse(order.file_paths).map((fileUrl, idx) => (
                      <div key={idx}>
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                          {fileUrl.split("/").pop()}
                        </a>
                      </div>
                    ))
                  }
                </td>
                <td>{new Date(order.created_at).toLocaleString()}</td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDeleteSubmittedOrder(order.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ));
  };
  // DELETE a submitted order by ID
  const handleDeleteSubmittedOrder = async (id) => {
    if (!window.confirm("Are you sure you want to delete this order ?"+ {id})) return;

    try {
      const response = await fetch(`${API_URL}/api/orders/${id}`, {
        method: "DELETE"
      });

      if (response.ok) {
        // Refresh the orders list
        const updated = await fetch(`${API_URL}/api/orders`).then(res => res.json());
        const now = new Date();
        const recent = updated.filter(order => (now - new Date(order.created_at)) / (1000 * 60 * 60 * 24) < 1);
        setSubmittedOrders({ recent, all: updated });
      } else {
        alert("Failed to delete the order.");
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      alert("An error occurred while deleting the order.");
    }
  };

  // DELETE a pending order before submission
  const handleDeletePendingOrder = (index) => {
    setOrders(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginLeft: 250, paddingTop: 20, marginBottom: 70 }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="btn btn-primary" onClick={() => setShowSubmittedModal(true)}>
          View All Submitted Orders
        </button>
        <button className="btn btn-secondary" onClick={() => setShowForm(!showForm)}>
          {showForm ? "Close Form" : "+ Add Order"}
        </button>
      </div>

      {showForm && (
        <div className="p-4 border rounded shadow-sm mb-4">
          <h5>Order Form</h5>
          <input className="form-control mb-2" placeholder="PO Number" value={poNumber} onChange={e => setPoNumber(e.target.value)} />
          <input className="form-control mb-2" placeholder="Product" name="product" value={currentOrder.product} onChange={handleChange} />
          <input className="form-control mb-2" placeholder="Description" name="desc" value={currentOrder.desc} onChange={handleChange} />
          <input className="form-control mb-2" placeholder="Qty" type="number" step="any" name="qty" value={currentOrder.qty} onChange={handleChange} />
          <input className="form-control mb-2" placeholder="Price" type="number" step="any" name="price" value={currentOrder.price} onChange={handleChange} />
          <input className="form-control mb-2" value={currentOrder.total} readOnly />

          <input type="file" name="files" multiple onChange={handleChange} className="form-control mb-2" />
          {currentOrder.files.map((file, idx) => (
            <div key={idx}>{file.name} <button onClick={() => handleRemoveFile(idx)}>Remove</button></div>
          ))}

          <button className="btn btn-secondary mb-3" onClick={handleAddOrder}>Add Order</button>

          {orders.length > 0 && (
            <>
              <h5>Pending Orders</h5>
              <table className="table table-bordered">
                <thead><tr><th>S.No</th><th>Product</th><th>Qty</th><th>Price</th><th>Total</th></tr></thead>
                <tbody>{orders.map((o, idx) => (
                  <tr key={idx}><td>{o.sno}</td><td>{o.product}</td><td>{o.qty}</td><td>{o.price}</td><td>{o.total}</td><td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDeletePendingOrder(idx)}
                  >
                    Delete
                  </button>
                </td></tr>
                ))}</tbody>
              </table>
              <button className="btn btn-success" onClick={handleSubmit}>Submit Orders</button>
            </>
          )}
        </div>
      )}

      <h5>Recently Submitted Orders (Last 24 Hours)</h5>
      {submittedOrders.recent.length > 0 ? renderOrderGroups(submittedOrders.recent) : <p>No recent orders.</p>}

      {showSubmittedModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">All Submitted BOB Orders</h5>
                <button type="button" className="btn-close" onClick={() => setShowSubmittedModal(false)}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search by PO Number, Order ID, or Product"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {submittedOrders.all.length > 0 ? renderOrderGroups(
                  submittedOrders.all.filter(order => 
                    (order.po_number || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                    String(order.id).includes(searchTerm) ||
                    (order.product || "").toLowerCase().includes(searchTerm.toLowerCase())
                  )
                ) : <p>No orders found.</p>}
                </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowSubmittedModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BobOrders;
